"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButtonState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const react_dom_1 = require("react-dom");
const slate_react_1 = require("slate-react");
const slate_1 = require("slate");
const link_1 = require("../../behavior/link");
class LinkButtonState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.draft = ui_1.rsync.val('');
        this.normalizedDraft = ui_1.rsync.comp([this.draft], ([draft]) => (0, link_1.normalizeLinkHref)(draft));
        /** Snapshot of the bounding rect of the trigger element at the moment `toggle()` was called. */
        this.anchorRect = ui_1.rsync.val(null);
        /** Snapshot of the editor selection when the popup opens. */
        this.rangeSnapshot = ui_1.rsync.val(null);
        this.setDraft = (value) => {
            this.draft.set(value);
        };
        this.setAnchorRect = (rect) => {
            this.anchorRect.set(rect);
        };
        this.setAnchorEl = (el) => {
            this.anchorRect.set(el ? el.getBoundingClientRect() : null);
        };
        this.setAnchorFromSelection = () => {
            try {
                const editor = this.editor;
                const sel = editor.selection;
                if (!sel) {
                    this.anchorRect.set(null);
                    return;
                }
                const domRange = slate_react_1.ReactEditor.toDOMRange(editor, sel);
                this.anchorRect.set(domRange.getBoundingClientRect());
            }
            catch {
                this.anchorRect.set(null);
            }
        };
        this.toggle = () => {
            if (!this.canOpen.value)
                return;
            const nextOpen = !this.open.value;
            if (nextOpen) {
                const active = this.activeLink.value;
                this.draft.set(active?.href ?? '');
                this.rangeSnapshot.set(active?.range ?? this.editor.selection ?? null);
            }
            else {
                this.rangeSnapshot.set(null);
            }
            this.open.set(nextOpen);
        };
        this.close = () => {
            const editor = this.editor;
            const range = this.rangeSnapshot.value;
            this.open.set(false);
            this.anchorRect.set(null);
            this.rangeSnapshot.set(null);
            if (range && typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
                window.requestAnimationFrame(() => {
                    try {
                        window.getSelection()?.removeAllRanges();
                    }
                    catch { }
                    try {
                        slate_1.Transforms.select(editor, range);
                    }
                    catch { }
                });
            }
        };
        this.apply = () => {
            const currentDraft = this.draft.value;
            const normalizedDraft = (0, link_1.normalizeLinkHref)(currentDraft);
            if (!normalizedDraft)
                return;
            (0, react_dom_1.flushSync)(() => this.open.set(false));
            const link = (0, link_1.upsertLink)(this.editor, currentDraft);
            if (!link) {
                this.draft.set(currentDraft);
                return;
            }
            this.draft.set(link.href);
        };
        this.remove = () => {
            const editor = this.editor;
            const range = this.rangeSnapshot.value;
            if (range) {
                try {
                    slate_1.Transforms.select(editor, range);
                }
                catch { }
            }
            if (!(0, link_1.removeLink)(editor, range ?? undefined))
                return;
            this.close();
        };
        const editor = (this.editor = mutxt.editor);
        this.activeLink = ui_1.rsync.comp([mutxt.cursor], () => (0, link_1.getActiveLink)(editor));
        this.canOpen = ui_1.rsync.comp([mutxt.readOnly, mutxt.selection, this.activeLink], ([readOnly, selection, activeLink]) => !readOnly && (!!selection || !!activeLink));
        this.selected = ui_1.rsync.comp([mutxt.readOnly, this.open, this.activeLink], ([readOnly, open, activeLink]) => !readOnly && (open || !!activeLink));
    }
}
exports.LinkButtonState = LinkButtonState;
